module.exports = __webpack_public_path__ + "static/TwoPhonesLeafs-34639a7bfadc686fb5ce210b29635bdc.png";